import MainCard from "./components/MainCard";

function App() {
  return <MainCard />;
}

export default App;
